// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/replace.js';

import { paths } from '../generated/replace';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('replace', Original, paths);
